"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentListModalHeadline = void 0;
const ContentListModalHeadline_1 = __importDefault(require("./ContentListModalHeadline"));
exports.ContentListModalHeadline = ContentListModalHeadline_1.default;
exports.default = ContentListModalHeadline_1.default;
